import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import ListadoDocumentos from '../listadoDocumentos/ListadoDocumentos';
import BuscarDocumentos from '../buscarDocumentos/BuscarDocumentos';
import PaginarDocumentos from '../listadoDocumentos/PaginarDocumentos';
import { clearErrors } from '../../actions';
import {
  ValidarEmisor,
  ValidarLogin,
  getCurrentDate,
  addDayToDate,
  getCasaMatriz
} from '../../util';
import { documentTypeEnum } from '../../enum';
import RenderHeader from '../shared/RenderHeader';

const Tiquetes = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);
  const { tiquetesState } = props;
  const [documentos, setDocumentos] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0)
  const [pageSize, setPageSize] = useState(15);
  const [request, setRequest] = useState({
    Identificacion: emisor?.Identificacion.Numero,
    CasaMatriz: getCasaMatriz(emisor?.usuario),
    FechaInicio: addDayToDate(getCurrentDate(), -30),
    FechaFin: addDayToDate(getCurrentDate(), + 1),
    NumeroPagina: 1,
    TamanoPagina: 15
  });

  useEffect(() => {
    props.clearErrors();

  }, []);

  useEffect(() => {
    if (tiquetesState !== null) {
      setDocumentos(tiquetesState.facturas.DocumentosElectronicos);
      setTotalRegistros(tiquetesState.facturas.TotalRegistros);
    }
  }, [tiquetesState]);

  const onNextPage = (pageNumber) => {
    setRequest({
      ...request,
      NumeroPagina: pageNumber,
      TamanoPagina: pageSize
    });
  };

  if (token === null) {
    return <Redirect to='/login' />;
  }

  return (
    <div className="ui Lista-facturas-container">

      <RenderHeader titulo="TIQUETES" />
      <BuscarDocumentos docType={documentTypeEnum.Tiquete} token={token} emisor={emisor} numeroPagina={request.NumeroPagina} tamanoPagina={request.TamanoPagina} />
      <ListadoDocumentos documentos={documentos} docType={documentTypeEnum.Tiquete} token={token} />
      <PaginarDocumentos pageSize={pageSize} totalRegistros={totalRegistros} onGetNextPage={(pageNumber) => {
        onNextPage(pageNumber);
      }} />
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    emisorState: state.emisorState,
    tiquetesState: state.tiquetesState,
  };
};

export default connect(mapStateToProps, { clearErrors })(Tiquetes);